/* eslint-disable @typescript-eslint/no-unused-vars */
import React from 'react';
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
import { Column } from './simpleTable';
import { checkIsDefined, FieldGetters } from 'src/utils';
import { Checkbox } from '@mui/material';
import { Button } from '../button';

import ICONS from 'src/utils/icons';
interface CustomTableRowProps<RowData, RowDataKey extends keyof RowData> {
  row: RowData;
  columns: Column<RowData>[];
  onRowClick?: (data: RowData) => void;
  onRowEdit?: (data: RowData) => void;
  onRowDelete?: (data: RowData) => void;
  onRowCheck?: (data: RowData) => void;
  getters?: FieldGetters;
  withCheckBox?: boolean;
  isChecked?: boolean;
}

function getFieldValue(row: any, name: string, getters: FieldGetters) {
  if (getters && getters[name]) {
    return getters[name](row, name);
  }
  return row[name];
}
function FormattedTableCell<T>({
  column,
  row,
  getters,
}: {
  column: Column<T>;
  row: any;
  getters: FieldGetters;
}) {
  if (
    !column.render &&
    !checkIsDefined(getFieldValue(row, column.field, getters))
  )
    return <>N/A</>;
  return <>{column.render ? column.render(row) : row[column.field]}</>;
}
const actionButtonsBaseStyles =
  'px-2 border border-gray-300 rounded-md w-auto text-gray-700 font-normal focus:outline-none hover:bg-transparent hover:border-1w-[1vw] border border-gray-300 rounded-md w-auto text-gray-700 font-normal focus:outline-none hover:bg-transparent hover:border-1';

export const CustomTableRow = <RowData, RowDataKey extends keyof RowData>({
  row,
  onRowClick,
  onRowEdit,
  onRowDelete,
  onRowCheck,
  columns,
  getters,
  withCheckBox = false,
  isChecked = false
}: CustomTableRowProps<RowData, RowDataKey>) => {
  const handleClick = () => {
    if (onRowClick) {
      onRowClick(row);
    }
  };

  const onRowEditClicked = (
    e: React.MouseEvent<HTMLButtonElement>,
    data: RowData
  ) => {
    try {
      e.stopPropagation();
      e.preventDefault();
      onRowEdit && onRowEdit(data);
    } catch (error) {
      console.log({ error });
    }
  };

  const onRowDeleteClicked = (
    e: React.MouseEvent<HTMLButtonElement>,
    data: RowData
  ) => {
    try {
      e.stopPropagation();
      e.preventDefault();
      onRowDelete && onRowDelete(data);
    } catch (error) {
      console.log({ error });
    }
  };

  const onRowCheckClicked = (
    e: React.ChangeEvent<HTMLInputElement> | React.MouseEvent<HTMLButtonElement>,
    data: RowData
  ) => {
    try {
      e.stopPropagation();
      e.preventDefault();
      onRowCheck && onRowCheck(data);
    } catch (error) {
      console.log({ error });
    }
  };

  return (
    <TableRow
      hover
      onClick={handleClick}
      sx={{
        '&:last-child td, &:last-child th': { border: 0 },
        cursor: onRowClick ? 'pointer' : 'default',
      }}
    >
      {withCheckBox && (
        <TableCell padding='checkbox' >
          <Checkbox
            color='primary'
            checked={isChecked}
            onChange={(e) => onRowCheckClicked(e, row)}
            onClick={(e) => onRowCheckClicked(e, row)}
          />
        </TableCell>
      )}
      {columns?.map((column) => (
        <TableCell
          key={column.field}
          align='left'
          sx={{ padding: '10px', color: '#344054' }}
        >
          <FormattedTableCell
            column={column}
            row={row}
            getters={getters || {}}
          />
        </TableCell>
      ))}
      {onRowEdit || onRowDelete ? (
        <TableCell align='left'  sx={{ padding: '10px' }}>
          {onRowEdit && (
            <Button
              className={`${actionButtonsBaseStyles} focus:border-blue-500 hover:border-gray mr-2`}
              variant='transparent'
              onClick={(e) => onRowEditClicked(e, row)}
              px='px-2'
            >
              {ICONS.EditIcon()}
            </Button>
          )}
          {onRowDelete && (
            <Button
              className={`${actionButtonsBaseStyles} focus:border-red-500 hover:border-red`}
              variant='transparent'
              onClick={(e) => onRowDeleteClicked(e, row)}
              px='px-2'
            >
              {ICONS.TrashIcon()}
            </Button>
          )}
        </TableCell>
      ) : null}
    </TableRow>
  );
};

export default CustomTableRow;
